import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Container, Modal, Accordion, Button } from "react-bootstrap";
import ReportModal from "./ReportModal";
import { Link, useLocation } from "react-router-dom";
import Video from "./video";
import Ppt from "./ppt";
import Doc from "./Doc";
import Audio from "./Audio";
import ImagePreview from "./ImagePreview";
import { useSelector } from "react-redux";
import {
  bulkGeneratePresignedUrl,
  generatePresignedUrl,
} from "../../../api/common-store-api";
import { IconPPT, IconDownload, IconReportIssue } from "../../../icons/Icons";
import DownloadLink from "./DownloadLink";
import { mapStatusToValue, getRemainingStringFileName } from "../../../common";
import { Title } from "@mui/icons-material";
import MessageWithReadMore from "../../../pages/Authoring/ContentPreview/MessageWithReadMore";

const PagePreview = ({
  actionReport,
  data,
  contentUrl,
  setContent,
  allData,
  userProfiles,
  currents,
  setActiveKey,
  activeKey,
  form,
}) => {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const ImgRef = useRef();
  const [seconds, setSeconds] = useState(0);
  const [current, setCurrent] = useState(0);
  const [contentUrlData, setContentUrlData] = useState(null);
  const userRole = useSelector(
    (state) => state.user.currentUser?.roles[0].name
  );
  const arrayDownloadableFiles = data?.downloadableFile;
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isFullScreenDoc, setIsFullScreenDoc] = useState(false);
  const [isFullScreenVideo, setIsFullScreenVideo] = useState(false);
  const [isFullScreenPpt, setIsFullScreenPpt] = useState(false);

  console.log(data, "datapage");
  console.log(allData, "allDatapage");

  const getPreviewUrl = async () => {
    let previewUrl = await generatePresignedUrl(contentUrl);
    if (previewUrl?.data) {
      setContentUrlData(previewUrl.data);
    }
  };

  const getDownloadUrl = async (data) => {
    let previewUrl = await generatePresignedUrl(data);
    if (previewUrl?.data) {
      console.log(previewUrl.data);
      return previewUrl.data;
    }
  };

  let downloadableFileURLs = [];
  const getBulkGeneratePresignedUrl = async (files) => {
    let responseURLsDownloadable = await bulkGeneratePresignedUrl(
      files.map((value) => value.filePath)
    );
    if (responseURLsDownloadable?.data) {
      return responseURLsDownloadable.data;
    }
  };

  useEffect(() => {
    getPreviewUrl();
  }, []);

  function isValidPhoto(fileName) {
    // if (fileName !== undefined) {
    if (fileName && typeof fileName === "string") {
      var allowed_extensions = new Array("jpg", "png", "jpeg");
      var file_extension = fileName.split(".").pop().toLowerCase();
      for (var i = 0; i <= allowed_extensions.length; i++) {
        if (allowed_extensions[i] == file_extension) {
          return true;
        }
      }
    }
    return false;
  }

  function isVideo(filename) {
    // console.log(filename,'filenamefilename');
    // if (filename !== undefined) {
    if (filename && typeof filename === "string") {
      var ext = filename.split(".").pop().toLowerCase();
      switch (ext.toLowerCase()) {
        case "m4v":
        case "mp4":
        case "mov":
          return true;
      }
    }
    return false;
  }

  const isValidPPT = (filename) => {
    console.log(filename, "filenamefilename");
    if (filename && typeof filename === "string") {
      var ext = filename.split(".").pop().toLowerCase();
      switch (ext.toLowerCase()) {
        case "pptx":
          return true;
      }
    }
    return false;
  };

  const isValidDocument = (filename) => {
    // if (filename !== undefined) {
    if (filename && typeof filename === "string") {
      var ext = filename.split(".").pop().toLowerCase();
      switch (ext.toLowerCase()) {
        case "pdf":
        case "doc":
        case "docx":
          return true;
      }
    }
    return false;
  };

  const isValidMusic = (filename) => {
    // if (filename !== undefined) {
    if (filename && typeof filename === "string") {
      var ext = filename.split(".").pop().toLowerCase();
      switch (ext.toLowerCase()) {
        case "mp3":
          return true;
      }
    }
    return false;
  };
  const title = () => {
    const getTitle = allData;
  };

  return (
    <div className="pages" style={{ height: "calc(100vh - 82px)" }}>
      {isFullScreen ? (
        <div className="p-4">
          <ImagePreview
            actionReport={actionReport}
            contentUrl={data.pageContentPath}
            slideData={data}
            setContent={setContent}
            form={form}
            setIsFullScreen={setIsFullScreen}
            isFullScreen={isFullScreen}
          />
        </div>
      ) : isFullScreenDoc ? (
        <Doc
          actionReport={actionReport}
          contentUrl={data.pageContentPath}
          slideData={data}
          setContent={setContent}
          setIsFullScreenDoc={setIsFullScreenDoc}
          isFullScreenDoc={isFullScreenDoc}
        />
      ) : isFullScreenVideo ? (
        <div className="overflow-auto h-100 w-100">
          <Video
            actionReport={actionReport}
            contentUrl={data.pageContentPath}
            slideData={data}
            setContent={setContent}
            setIsFullScreenVideo={setIsFullScreenVideo}
            isFullScreenVideo={isFullScreenVideo}
          />
        </div>
      ) : isFullScreenPpt ? (
        <Ppt
          actionReport={actionReport}
          contentUrl={data.pageContentPath}
          slideData={data}
          setContent={setContent}
          setIsFullScreenPpt={setIsFullScreenPpt}
          isFullScreenPpt={isFullScreenPpt}
        />
      ) : (
        <div className="pageOuter p-0 bg-base-100">
          <div className="d-flex flex-column h-100">
            <div className="w-100 flex-grow-1 h-100 overflow-auto">
              <Row className="g-0 d-flex h-100">
                <Col className="col-lg-9 flex-grow-1 overflow-auto h-100">
                  {isVideo(data.pageContentPath) ? (
                    <div className="p-32 pb-0">
                      <div className="rounded-6 border d-flex flex-column flex-grow-1">
                        <div className="">
                          <Video
                            actionReport={actionReport}
                            contentUrl={data.pageContentPath}
                            slideData={data}
                            setContent={setContent}
                            setIsFullScreenVideo={setIsFullScreenVideo}
                            isFullScreenVideo={isFullScreenVideo}
                          />
                        </div>
                        <div className="p-32 bg-gray-600 rounded-bottom-3 ">
                          <div className="catlogHeading d-flex">
                            <div className="count">
                              <span className="roundCount">{currents + 1}</span>
                            </div>
                            <div className="ms-3 ps-1">
                              <h4>{data.title}</h4>
                              <p className="text-sm text-gray-200 pt-1 pb-1 mb-2 text-break">
                                {data.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : isValidPhoto(data.pageContentPath) ? (
                    <div className="p-32 pb-4">
                      <div className="rounded-6 border d-flex flex-column flex-grow-1">
                        <div className="">
                          <ImagePreview
                            actionReport={actionReport}
                            contentUrl={data.pageContentPath}
                            slideData={data}
                            setContent={setContent}
                            form={form}
                            setIsFullScreen={setIsFullScreen}
                          />
                        </div>
                        <div className="p-32 bg-gray-600 rounded-bottom-3">
                          <div className="catlogHeading d-flex">
                            <div className="count">
                              <span className="roundCount">{currents + 1}</span>
                            </div>
                            <div className="ms-3 ps-1">
                              <h4>{data.title}</h4>
                              <p className="text-sm text-gray-200 pt-1 pb-1 mb-2 text-break">
                                {data.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : isValidPPT(data.pageContentPath) ? (
                    <div className="p-32 pb-4">
                      <div className="rounded-6 border d-flex flex-column flex-grow-1">
                        <div className="">
                          <Ppt
                            actionReport={actionReport}
                            contentUrl={data.pageContentPath}
                            slideData={data}
                            setContent={setContent}
                            setIsFullScreenPpt={setIsFullScreenPpt}
                            isFullScreenPpt={isFullScreenPpt}
                          />
                        </div>
                        <div className="p-32 bg-gray-600 rounded-bottom-3">
                          <div className="catlogHeading d-flex">
                            <div className="count">
                              <span className="roundCount">{currents + 1}</span>
                            </div>
                            <div className="ms-3 ps-1">
                              <h4>{data.title}</h4>
                              <p className="text-sm text-gray-200 pt-1 pb-1 mb-2 text-break">
                                {data.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : isValidDocument(data.pageContentPath) ? (
                    <div className="pb-0 px-32 pt-32">
                      <div className="rounded-6 border h-100 d-flex flex-column flex-grow-1 overflow-auto">
                        <div
                          className="w-100 flex-grow-1"
                          style={{ height: "calc(100vh - 270px)" }}
                        >
                          <Doc
                            actionReport={actionReport}
                            contentUrl={data.pageContentPath}
                            slideData={data}
                            setContent={setContent}
                            setIsFullScreenDoc={setIsFullScreenDoc}
                            isFullScreenDoc={isFullScreenDoc}
                          />
                        </div>
                        <div className="p-32 bg-gray-600 rounded-bottom-3">
                          <div className="catlogHeading d-flex">
                            <div className="count">
                              <span className="roundCount">{currents + 1}</span>
                            </div>
                            <div className="ms-3 ps-1">
                              <h4>{data.title}</h4>
                              <p className="text-sm text-gray-200 pt-1 pb-1 mb-2 text-break">
                                {data.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : isValidMusic(data.pageContentPath) ? (
                    <div className="p-32 pb-4">
                      <div className="rounded-6 border d-flex flex-column flex-grow-1">
                        <div className="">
                          <Audio
                            actionReport={actionReport}
                            contentUrl={data.pageContentPath}
                            slideData={data}
                            setContent={setContent}
                          />
                        </div>
                        <div className="p-32 bg-gray-600 rounded-bottom-3">
                          <div className="catlogHeading d-flex">
                            <div className="count">
                              <span className="roundCount">{currents + 1}</span>
                            </div>
                            <div className="ms-3 ps-1">
                              <h4>{data.title}</h4>
                              <p className="text-sm text-gray-200 pt-1 pb-1 mb-2 text-break">
                                {data.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </Col>
                <Col className="col-lg-3 flex-grow-1 h-100 catalogSidebar">
                  <div className="bg-gray-600 p-20 py-32 h-100 borderLeft2 overflow-auto">
                    <h5 className="pb-2">Next in queue</h5>
                    {allData &&
                      allData.length > 0 &&
                      allData.map((item, index) =>
                        item.form !== null ? (
                          <div
                            className={`catlogHeading d-flex my-3 ${
                              currents === index ? "active" : ""
                            }`}
                          >
                            <div className="count">
                              <span className="roundCount">{index + 1}</span>
                            </div>
                            <div className="ms-1 px-3 acContent">
                              {currents === index && (
                                <span class="tableTag text-md mb-2">
                                  {mapStatusToValue(item.status)}
                                </span>
                              )}
                              <h4>
                                {item.form === null
                                  ? item.page.title
                                  : item.form.title}
                              </h4>
                            </div>
                          </div>
                        ) : (
                          <Accordion
                            defaultActiveKey={allData.map((item, index) =>
                              currents === index ? index : null
                            )}
                            className="catlogAccordion"
                          >
                            <Accordion.Item
                              eventKey={index}
                              disabled={true}
                              className="mb-3"
                              key={item.id}
                            >
                              <Accordion.Header>
                                <div
                                  className={`catlogHeading d-flex my-3 ${
                                    currents === index ? "active" : ""
                                  }`}
                                >
                                  <div className="count">
                                    <span className="roundCount">
                                      {index + 1}
                                    </span>
                                  </div>
                                  <div className="ms-1 px-3 acContent">
                                    <span class="tableTag text-md mb-2">
                                      {mapStatusToValue(item.status)}
                                    </span>
                                    <h4>
                                      {item.page === null
                                        ? item.form.title
                                        : item.page.title}
                                    </h4>
                                  </div>
                                </div>
                              </Accordion.Header>
                              <Accordion.Body>
                                {/* {item?.page?.downloadableFile.length > 0 && ( */}
                                <div className="mb-4">
                                  <h6 className="mb-20">Resources</h6>
                                  {item?.page?.downloadableFile !== undefined &&
                                    item?.page?.downloadableFile !== null &&
                                    item?.page?.downloadableFile.length > 0 &&
                                    item?.page?.downloadableFile.map(
                                      (value, index, array) => (
                                        <div className="d-flex justify-content-between align-items-center mb-20">
                                          <div className="d-flex gap-3 align-items-center w-100">
                                            <div>
                                              <IconPPT />
                                            </div>
                                            <div className="w-100 pe-4">
                                              <p className="singleLineEc mb-0 text-break text-sm">
                                                {getRemainingStringFileName(
                                                  value.filePath
                                                )}
                                              </p>
                                              {/* <p className="mb-0 text-gray-300 text-12 pt-1">1.27 MB</p> */}
                                            </div>
                                          </div>
                                          <DownloadLink url={value.filePath} />
                                        </div>
                                      )
                                    )}

                                  {arrayDownloadableFiles === undefined ||
                                  arrayDownloadableFiles.length === 0 ? (
                                    <div className="p-20 bg-base-100 rounded-6">
                                      <p className="text-md text-gray-200">
                                        Looks like no resources have been added
                                        yet.
                                      </p>
                                    </div>
                                  ) : null}
                                </div>
                                {/* )} */}
                                {/* {item?.page?.messages?.length > 0 && ( */}
                                <div className="mb-0">
                                  <h6 className="mb-20">Message from Author</h6>
                                  <div className="p-20 bg-base-100 rounded-6">
                                    {/* <p className="text-md text-gray-200"> */}
                                    {/* {item?.page?.messages && item?.page?.messages[0]?.message ? item?.page?.messages[0]?.message : 'Looks like the author has not added any message yet.'} */}
                                    <MessageWithReadMore
                                      message={
                                        item?.page?.messages &&
                                        item?.page?.messages[0]?.message
                                      }
                                    />
                                    {/* </p> */}
                                  </div>
                                </div>
                                {/* )} */}
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        )
                      )}
                    {/* {userProfiles && userProfiles.roleName === "Employee" && ( */}
                    {userProfiles &&
                      userProfiles.switchedRoleName === "Employee" && (
                        <div className="d-flex gap-2 align-items-center">
                          <div>
                            <IconReportIssue />
                          </div>

                          <button
                            className="text-primary-200 h6 font-bold"
                            onClick={() => {
                              setContent(data);
                              actionReport(true);
                            }}
                          >
                            Report an issue
                          </button>
                        </div>
                      )}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PagePreview;
